export const USER_STATUS_FILTERS = ['active', 'inactive', 'all'] as const;

export type UserStatusFilter = typeof USER_STATUS_FILTERS[number];

export const USER_STATUS_FILTER_LABELS: Record<UserStatusFilter, string> = {
  active: 'Actifs',
  inactive: 'Désactivés',
  all: 'Tous',
};
